import { useGetLabels } from '@ipfabric/api-client/client/model/labels/labels';

export const useLabelsQuery = () => useGetLabels();
